export enum PaymentType {
  CreditCard = 0,
  Pledge = 1,
  PayrollDeduction = 2,
  PayPal = 3,
  UnifiedCheckout = 4
}
